import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { Palette } from '@/themes/themeOverrides/Palette';

const ConditionalFieldDisplay = ({ label, value, emptyText }) => {
    const translate = useTranslate();

    if (!value) {
        return (
            <Box label={label}>
                <Typography variant='caption' style={{ color: Palette.gray.gray400 }}>
                    {emptyText || translate('common.shortage')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box label={label}>
            <Typography variant='caption'>{value}</Typography>
        </Box>
    );
};

ConditionalFieldDisplay.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    emptyText: PropTypes.string,
};

export default ConditionalFieldDisplay;
